export default __webpack_public_path__ + "static/media/video-question-troubleshoot-1.0944dcff.png";